var map = {
	"./All.svg": 843,
	"./Casino.svg": 844,
	"./Connect.svg": 845,
	"./Fish Games.svg": 846,
	"./Lottery.svg": 847,
	"./Poker.svg": 848,
	"./RNG.svg": 849,
	"./Slots.svg": 850,
	"./Sports.svg": 851,
	"./Virtual-Sports.svg": 852,
	"./eSports.svg": 853,
	"./pagcorlogo2.svg": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;